export const transferOutTranslations = {
  en: {
    'transferOut.title': 'Transfer Out',
    'transferOut.subtitle': 'Transfer funds from your {{currency}} balance to your payment methods',
    'transferOut.backToProfile': 'Back to Profile',
    'transferOut.currentBalance': 'Current Balance',
    'transferOut.available': 'Available for transfer',
    'transferOut.cannotTransfer': 'Cannot Transfer',
    'transferOut.unsupportedCurrency': 'PayPal does not support {{currency}} transfers',
    'transferOut.noMethods': 'No payment methods available for {{currency}} transfers',
    'transferOut.addMethod': 'Add Payment Method',
    'transferOut.noBalance': 'You have no {{currency}} balance to transfer. Add funds to your balance first.',
    'transferOut.amountTitle': 'Transfer Amount',
    'transferOut.amountSubtitle': 'Enter the amount you want to transfer (max: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Amount ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Max',
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Loading transfer information...',
    'transferOut.paypalSetupAlert':
      'You can add and verify a PayPal payout email under Profile → Payouts (transfer out), then come back here whenever you’re ready.',
    'transferOut.openProfile': 'Open profile',
    'transferOut.paymentSources': 'Payment sources',
    'transferOut.payoutSetupTitle': 'More payout options',
    'transferOut.payoutSetupIntro':
      'You can add or manage payout methods anytime in Profile → Payouts (transfer out) or Payment sources. To use an option below, turn it on there first:',
    'transferOut.payoutSetupPaypal': 'PayPal — add and verify a payout email.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — link your seller account for direct transfers (merchants).',
    'transferOut.payoutSetupBank':
      'Bank account — connect a bank in Payment sources and enable bank payouts in Profile.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Stripe processing fee:',
    'transferOut.stripeFeeNote':
      'Note: Stripe charges {{fee}} for this payout. This fee is included in the total deducted from your balance.',
    'transferOut.selectMethod': 'Select Payment Method',
    'transferOut.selectMethodSubtitle': 'Choose where you want to transfer your {{currency}}',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Transfer to your PayPal account',
    'transferOut.setPaypalId': 'Set your PayPal ID',
    'transferOut.creditCard': 'Credit Card',
    'transferOut.bankAccount': 'Bank Account',
    'transferOut.default': 'Default',
    'transferOut.enterPaypalEmail': 'Enter your PayPal email address',
    'transferOut.confirm': 'Confirm',
    'transferOut.emailSaved': 'This email will be saved for future transfers',
    'transferOut.summaryTitle': 'Transfer Summary',
    'transferOut.reviewTransferHint':
      'Enter an amount and select a payment method to see fees and complete your transfer.',
    'transferOut.amountFromBalance': 'Amount from your balance:',
    'transferOut.paypalFee': 'PayPal processing fee:',
    'transferOut.youWillReceive': 'You will receive:',
    'transferOut.feeNote': 'Note: PayPal charges {{fee}} for receiving payments. This fee is deducted by PayPal, not by us.',
    'transferOut.bankFee': 'Bank transfer fee:',
    'transferOut.totalDeducted': 'Total deducted from balance:',
    'transferOut.processing': 'Processing Transfer...',
    'transferOut.transferFunds': 'Transfer Funds',
    'transferOut.insufficientBalance': 'Insufficient balance to cover transfer amount and fees',
    'transferOut.toast.error': 'Failed to load transfer information',
    'transferOut.toast.noMethodOrAmount': 'Please select a payment method and enter an amount',
    'transferOut.toast.noPaypalEmail': 'Please enter your PayPal email address',
    'transferOut.toast.invalidEmail': 'Please enter a valid email address',
    'transferOut.toast.invalidAmount': 'Please enter a valid amount',
    'transferOut.toast.insufficientBalance': 'Transfer amount exceeds available balance',
    'transferOut.toast.verifyPaypalProfile':
      'Verify your PayPal email on your profile before transferring.',
    'transferOut.toast.successPaypal': 'Transfer successful! {{amount}} {{currency}} transferred to {{recipient}}. Payout ID: {{payoutId}}',
    'transferOut.toast.successBank': 'Transfer initiated! {{amount}} {{currency}} transfer has been processed.',
    'transferOut.toast.errorTransfer': 'Failed to initiate transfer',
  },
  es: {
    'transferOut.title': 'Transferir Fondos',
    'transferOut.subtitle': 'Transfiere fondos de tu saldo de {{currency}} a tus métodos de pago',
    'transferOut.backToProfile': 'Volver al Perfil',
    'transferOut.currentBalance': 'Saldo Actual',
    'transferOut.available': 'Disponible para transferir',
    'transferOut.cannotTransfer': 'No se puede transferir',
    'transferOut.unsupportedCurrency': 'PayPal no admite transferencias en {{currency}}',
    'transferOut.noMethods': 'No hay métodos de pago disponibles para transferencias en {{currency}}',
    'transferOut.addMethod': 'Añadir Método de Pago',
    'transferOut.noBalance': 'No tienes saldo en {{currency}} para transferir. Añade fondos a tu saldo primero.',
    'transferOut.amountTitle': 'Monto a Transferir',
    'transferOut.amountSubtitle': 'Introduce el monto que quieres transferir (máx: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Monto ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Máx',
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Cargando información de la transferencia...',
    'transferOut.paypalSetupAlert':
      'Puedes añadir y verificar un correo de PayPal en Perfil → Pagos (transferencia saliente) y volver aquí cuando quieras.',
    'transferOut.openProfile': 'Abrir perfil',
    'transferOut.paymentSources': 'Fuentes de pago',
    'transferOut.payoutSetupTitle': 'Más opciones de cobro',
    'transferOut.payoutSetupIntro':
      'Puedes añadir o gestionar métodos de cobro cuando quieras en Perfil → Pagos (transferencia saliente) o Fuentes de pago. Para usar una de las opciones de abajo, actívala allí primero:',
    'transferOut.payoutSetupPaypal': 'PayPal — añade y verifica un correo de cobros.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — vincula tu cuenta de vendedor para cobros directos (comercios).',
    'transferOut.payoutSetupBank':
      'Cuenta bancaria — conecta un banco en Fuentes de pago y activa cobros por banco en Perfil.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Comisión de procesamiento Stripe:',
    'transferOut.stripeFeeNote':
      'Nota: Stripe cobra {{fee}} por esta transferencia. La comisión está incluida en el total deducido de tu saldo.',
    'transferOut.selectMethod': 'Seleccionar Método de Pago',
    'transferOut.selectMethodSubtitle': 'Elige a dónde quieres transferir tu {{currency}}',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Transferir a tu cuenta de PayPal',
    'transferOut.setPaypalId': 'Establece tu ID de PayPal',
    'transferOut.creditCard': 'Tarjeta de Crédito',
    'transferOut.bankAccount': 'Cuenta Bancaria',
    'transferOut.default': 'Predeterminado',
    'transferOut.enterPaypalEmail': 'Introduce tu dirección de correo electrónico de PayPal',
    'transferOut.confirm': 'Confirmar',
    'transferOut.emailSaved': 'Este correo electrónico se guardará para futuras transferencias',
    'transferOut.summaryTitle': 'Resumen de la Transferencia',
    'transferOut.reviewTransferHint':
      'Introduce un monto y selecciona un método de pago para ver comisiones y completar la transferencia.',
    'transferOut.amountFromBalance': 'Monto de tu saldo:',
    'transferOut.paypalFee': 'Comisión de procesamiento de PayPal:',
    'transferOut.youWillReceive': 'Recibirás:',
    'transferOut.feeNote': 'Nota: PayPal cobra un {{fee}} por recibir pagos. Esta comisión es deducida por PayPal, no por nosotros.',
    'transferOut.bankFee': 'Comisión por transferencia bancaria:',
    'transferOut.totalDeducted': 'Total deducido del saldo:',
    'transferOut.processing': 'Procesando Transferencia...',
    'transferOut.transferFunds': 'Transferir Fondos',
    'transferOut.insufficientBalance': 'Saldo insuficiente para cubrir el monto de la transferencia y las comisiones',
    'transferOut.toast.error': 'No se pudo cargar la información de la transferencia',
    'transferOut.toast.noMethodOrAmount': 'Por favor, selecciona un método de pago e introduce un monto',
    'transferOut.toast.noPaypalEmail': 'Por favor, introduce tu dirección de correo electrónico de PayPal',
    'transferOut.toast.invalidEmail': 'Por favor, introduce una dirección de correo electrónico válida',
    'transferOut.toast.invalidAmount': 'Por favor, introduce un monto válido',
    'transferOut.toast.insufficientBalance': 'El monto de la transferencia excede el saldo disponible',
    'transferOut.toast.verifyPaypalProfile':
      'Verifica tu correo de PayPal en tu perfil antes de transferir.',
    'transferOut.toast.successPaypal': '¡Transferencia exitosa! Se han transferido {{amount}} {{currency}} a {{recipient}}. ID de pago: {{payoutId}}',
    'transferOut.toast.successBank': '¡Transferencia iniciada! Se ha procesado la transferencia de {{amount}} {{currency}}.',
    'transferOut.toast.errorTransfer': 'No se pudo iniciar la transferencia',
  },
  fr: {
    'transferOut.title': 'Transférer des fonds',
    'transferOut.subtitle': 'Transférez des fonds de votre solde {{currency}} vers vos méthodes de paiement',
    'transferOut.backToProfile': 'Retour au profil',
    'transferOut.currentBalance': 'Solde actuel',
    'transferOut.available': 'Disponible pour transfert',
    'transferOut.cannotTransfer': 'Impossible de transférer',
    'transferOut.unsupportedCurrency': 'PayPal ne prend pas en charge les transferts en {{currency}}',
    'transferOut.noMethods': 'Aucune méthode de paiement disponible pour les transferts en {{currency}}',
    'transferOut.addMethod': 'Ajouter une méthode de paiement',
    'transferOut.noBalance': 'Vous n\'avez pas de solde {{currency}} à transférer. Ajoutez d\'abord des fonds à votre solde.',
    'transferOut.amountTitle': 'Montant à transférer',
    'transferOut.amountSubtitle': 'Entrez le montant que vous souhaitez transférer (max : {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Montant ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Max',
    'transferOut.pct25': '25 %',
    'transferOut.pct50': '50 %',
    'transferOut.pct75': '75 %',
    'transferOut.loading': 'Chargement des informations de transfert...',
    'transferOut.paypalSetupAlert':
      'Vous pouvez ajouter et vérifier une adresse PayPal sous Profil → Paiements (transfert sortant), puis revenir ici quand vous voulez.',
    'transferOut.openProfile': 'Ouvrir le profil',
    'transferOut.paymentSources': 'Sources de paiement',
    'transferOut.payoutSetupTitle': 'Plus d’options de versement',
    'transferOut.payoutSetupIntro':
      'Vous pouvez ajouter ou gérer des moyens de versement à tout moment dans Profil → Paiements (transfert sortant) ou Sources de paiement. Pour utiliser une option ci-dessous, activez-la d’abord :',
    'transferOut.payoutSetupPaypal': 'PayPal — ajoutez et vérifiez une adresse e-mail de versement.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — liez votre compte vendeur pour des virements directs (commerçants).',
    'transferOut.payoutSetupBank':
      'Compte bancaire — connectez une banque dans Sources de paiement et activez les virements dans Profil.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Frais de traitement Stripe :',
    'transferOut.stripeFeeNote':
      'Note : Stripe facture {{fee}} pour ce paiement. Les frais sont inclus dans le total déduit de votre solde.',
    'transferOut.selectMethod': 'Sélectionner une méthode de paiement',
    'transferOut.selectMethodSubtitle': 'Choisissez où vous souhaitez transférer votre {{currency}}',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Transférer vers votre compte PayPal',
    'transferOut.setPaypalId': 'Définir votre ID PayPal',
    'transferOut.creditCard': 'Carte de crédit',
    'transferOut.bankAccount': 'Compte bancaire',
    'transferOut.default': 'Par défaut',
    'transferOut.enterPaypalEmail': 'Entrez votre adresse e-mail PayPal',
    'transferOut.confirm': 'Confirmer',
    'transferOut.emailSaved': 'Cette adresse e-mail sera enregistrée pour les transferts futurs',
    'transferOut.summaryTitle': 'Résumé du transfert',
    'transferOut.amountFromBalance': 'Montant de votre solde :',
    'transferOut.paypalFee': 'Frais de traitement PayPal :',
    'transferOut.youWillReceive': 'Vous recevrez :',
    'transferOut.feeNote': 'Note : PayPal facture {{fee}} pour recevoir des paiements. Ces frais sont déduits par PayPal, pas par nous.',
    'transferOut.bankFee': 'Frais de virement bancaire :',
    'transferOut.totalDeducted': 'Total déduit du solde :',
    'transferOut.processing': 'Traitement du transfert...',
    'transferOut.transferFunds': 'Transférer les fonds',
    'transferOut.insufficientBalance': 'Solde insuffisant pour couvrir le montant du transfert et les frais',
    'transferOut.toast.error': 'Échec du chargement des informations de transfert',
    'transferOut.toast.noMethodOrAmount': 'Veuillez sélectionner une méthode de paiement et entrer un montant',
    'transferOut.toast.noPaypalEmail': 'Veuillez entrer votre adresse e-mail PayPal',
    'transferOut.toast.invalidEmail': 'Veuillez entrer une adresse e-mail valide',
    'transferOut.toast.invalidAmount': 'Veuillez entrer un montant valide',
    'transferOut.toast.insufficientBalance': 'Le montant du transfert dépasse le solde disponible',
    'transferOut.toast.verifyPaypalProfile':
      'Vérifiez votre e-mail PayPal sur votre profil avant de transférer.',
    'transferOut.toast.successPaypal': 'Transfert réussi ! {{amount}} {{currency}} transféré à {{recipient}}. ID de paiement : {{payoutId}}',
    'transferOut.toast.successBank': 'Transfert initié ! Le transfert de {{amount}} {{currency}} a été traité.',
    'transferOut.toast.errorTransfer': 'Échec de l\'initiation du transfert',
  },
  sq: {
    'transferOut.title': 'Transferim Jashtë',
    'transferOut.subtitle': 'Transferoni fonde nga bilanci juaj {{currency}} në metodat tuaja të pagesës',
    'transferOut.backToProfile': 'Kthehu te Profili',
    'transferOut.currentBalance': 'Bilanci Aktual',
    'transferOut.available': 'Në dispozicion për transferim',
    'transferOut.cannotTransfer': 'Nuk Mund të Transferohet',
    'transferOut.unsupportedCurrency': 'PayPal nuk mbështet transferta në {{currency}}',
    'transferOut.noMethods': 'Nuk ka metoda pagese të disponueshme për transferta në {{currency}}',
    'transferOut.addMethod': 'Shto Metodë Pagese',
    'transferOut.noBalance': 'Nuk keni bilanc {{currency}} për të transferuar. Shtoni fonde në bilancin tuaj fillimisht.',
    'transferOut.amountTitle': 'Shuma e Transferimit',
    'transferOut.amountSubtitle': 'Shkruani shumën që dëshironi të transferoni (maks: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Shuma ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Maks',
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Duke ngarkuar informacionin e transferimit...',
    'transferOut.paypalSetupAlert':
      'Mund të shtoni dhe verifikoni një email PayPal te Profili → Pagesat (transfer jashtë), pastaj të ktheheni këtu kur të doni.',
    'transferOut.openProfile': 'Hap profilin',
    'transferOut.paymentSources': 'Burimet e pagesës',
    'transferOut.payoutSetupTitle': 'Më shumë opsione pagesash',
    'transferOut.payoutSetupIntro':
      'Mund të shtoni ose menaxhoni metoda pagesash kur të doni te Profili → Pagesat (transfer jashtë) ose Burimet e pagesës. Për të përdorur një opsion më poshtë, aktivizojeni atje fillimisht:',
    'transferOut.payoutSetupPaypal': 'PayPal — shtoni dhe verifikoni një email pagesash.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — lidhni llogarinë tuaj të shitësit për transferta të drejtpërdrejta (tregtarë).',
    'transferOut.payoutSetupBank':
      'Llogaria bankare — lidhni një bankë te Burimet e pagesës dhe aktivizoni pagesat bankare te Profili.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Tarifa e përpunimit Stripe:',
    'transferOut.stripeFeeNote':
      'Shënim: Stripe ngarkon {{fee}} për këtë pagesë. Tarifa përfshihet në totalin e zbritur nga bilanci.',
    'transferOut.selectMethod': 'Zgjidhni Metodën e Pagesës',
    'transferOut.selectMethodSubtitle': 'Zgjidhni ku dëshironi të transferoni {{currency}} tuaj',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Transferoni në llogarinë tuaj PayPal',
    'transferOut.setPaypalId': 'Vendosni ID-në tuaj të PayPal',
    'transferOut.creditCard': 'Kartë Krediti',
    'transferOut.bankAccount': 'Llogari Bankare',
    'transferOut.default': 'Parazgjedhje',
    'transferOut.enterPaypalEmail': 'Shkruani adresën tuaj email të PayPal',
    'transferOut.confirm': 'Konfirmo',
    'transferOut.emailSaved': 'Ky email do të ruhet për transferta të ardhshme',
    'transferOut.summaryTitle': 'Përmbledhja e Transferimit',
    'transferOut.reviewTransferHint':
      'Shkruani një shumë dhe zgjidhni një metodë pagese për të parë tarifat dhe për të përfunduar transferimin.',
    'transferOut.amountFromBalance': 'Shuma nga bilanci juaj:',
    'transferOut.paypalFee': 'Tarifa e përpunimit të PayPal:',
    'transferOut.youWillReceive': 'Ju do të merrni:',
    'transferOut.feeNote': 'Shënim: PayPal ngarkon {{fee}} për marrjen e pagesave. Kjo tarifë zbritet nga PayPal, jo nga ne.',
    'transferOut.bankFee': 'Tarifa e transferimit bankar:',
    'transferOut.totalDeducted': 'Totali i zbritur nga bilanci:',
    'transferOut.processing': 'Duke përpunuar transferimin...',
    'transferOut.transferFunds': 'Transfero Fondet',
    'transferOut.insufficientBalance': 'Bilanc i pamjaftueshëm për të mbuluar shumën e transferimit dhe tarifat',
    'transferOut.toast.error': 'Dështoi ngarkimi i informacionit të transferimit',
    'transferOut.toast.noMethodOrAmount': 'Ju lutemi zgjidhni një metodë pagese dhe shkruani një shumë',
    'transferOut.toast.noPaypalEmail': 'Ju lutemi shkruani adresën tuaj email të PayPal',
    'transferOut.toast.invalidEmail': 'Ju lutemi shkruani një adresë email të vlefshme',
    'transferOut.toast.invalidAmount': 'Ju lutemi shkruani një shumë të vlefshme',
    'transferOut.toast.insufficientBalance': 'Shuma e transferimit tejkalon bilancin e disponueshëm',
    'transferOut.toast.verifyPaypalProfile':
      'Verifikoni email-in tuaj PayPal në profil para se të transferoni.',
    'transferOut.toast.successPaypal': 'Transferimi i suksesshëm! {{amount}} {{currency}} u transferua te {{recipient}}. ID e pagesës: {{payoutId}}',
    'transferOut.toast.successBank': 'Transferimi u nis! Transferimi i {{amount}} {{currency}} është përpunuar.',
    'transferOut.toast.errorTransfer': 'Dështoi nisja e transferimit',
  },
  ru: {
    'transferOut.title': 'Перевод средств',
    'transferOut.subtitle': 'Переведите средства с вашего баланса {{currency}} на ваши способы оплаты',
    'transferOut.backToProfile': 'Вернуться к профилю',
    'transferOut.currentBalance': 'Текущий баланс',
    'transferOut.available': 'Доступно для перевода',
    'transferOut.cannotTransfer': 'Нельзя перевести',
    'transferOut.unsupportedCurrency': 'PayPal не поддерживает переводы в {{currency}}',
    'transferOut.noMethods': 'Нет доступных способов оплаты для переводов в {{currency}}',
    'transferOut.addMethod': 'Добавить способ оплаты',
    'transferOut.noBalance': 'У вас нет баланса {{currency}} для перевода. Сначала пополните баланс.',
    'transferOut.amountTitle': 'Сумма перевода',
    'transferOut.amountSubtitle': 'Введите сумму, которую хотите перевести (макс: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Сумма ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Макс',
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Загрузка информации о переводе...',
    'transferOut.paypalSetupAlert':
      'Вы можете добавить и подтвердить email PayPal в Профиль → Выплаты (исходящий перевод) и вернуться сюда, когда будете готовы.',
    'transferOut.openProfile': 'Открыть профиль',
    'transferOut.paymentSources': 'Способы пополнения',
    'transferOut.payoutSetupTitle': 'Дополнительные способы выплат',
    'transferOut.payoutSetupIntro':
      'Вы можете в любое время добавить или изменить способы выплат в Профиль → Выплаты (исходящий перевод) или в способах пополнения. Чтобы использовать вариант ниже, сначала включите его там:',
    'transferOut.payoutSetupPaypal': 'PayPal — добавьте и подтвердите email для выплат.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — привяжите аккаунт продавца для прямых переводов (мерчанты).',
    'transferOut.payoutSetupBank':
      'Банк — подключите счёт в способах пополнения и включите банковские выплаты в Профиле.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Комиссия Stripe:',
    'transferOut.stripeFeeNote':
      'Примечание: Stripe взимает {{fee}} за эту выплату. Комиссия включена в сумму, списанную с баланса.',
    'transferOut.selectMethod': 'Выберите способ оплаты',
    'transferOut.selectMethodSubtitle': 'Выберите, куда вы хотите перевести ваши {{currency}}',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Перевод на ваш аккаунт PayPal',
    'transferOut.setPaypalId': 'Установите ваш PayPal ID',
    'transferOut.creditCard': 'Кредитная карта',
    'transferOut.bankAccount': 'Банковский счет',
    'transferOut.default': 'По умолчанию',
    'transferOut.enterPaypalEmail': 'Введите ваш адрес email PayPal',
    'transferOut.confirm': 'Подтвердить',
    'transferOut.emailSaved': 'Этот email будет сохранен для будущих переводов',
    'transferOut.summaryTitle': 'Сводка перевода',
    'transferOut.reviewTransferHint':
      'Введите сумму и выберите способ оплаты, чтобы увидеть комиссии и завершить перевод.',
    'transferOut.amountFromBalance': 'Сумма с вашего баланса:',
    'transferOut.paypalFee': 'Комиссия обработки PayPal:',
    'transferOut.youWillReceive': 'Вы получите:',
    'transferOut.feeNote': 'Примечание: PayPal взимает {{fee}} за получение платежей. Эта комиссия вычитается PayPal, а не нами.',
    'transferOut.bankFee': 'Комиссия банковского перевода:',
    'transferOut.totalDeducted': 'Всего вычтено с баланса:',
    'transferOut.processing': 'Обработка перевода...',
    'transferOut.transferFunds': 'Перевести средства',
    'transferOut.insufficientBalance': 'Недостаточно баланса для покрытия суммы перевода и комиссий',
    'transferOut.toast.error': 'Не удалось загрузить информацию о переводе',
    'transferOut.toast.noMethodOrAmount': 'Пожалуйста, выберите способ оплаты и введите сумму',
    'transferOut.toast.noPaypalEmail': 'Пожалуйста, введите ваш адрес email PayPal',
    'transferOut.toast.invalidEmail': 'Пожалуйста, введите действительный адрес email',
    'transferOut.toast.invalidAmount': 'Пожалуйста, введите действительную сумму',
    'transferOut.toast.insufficientBalance': 'Сумма перевода превышает доступный баланс',
    'transferOut.toast.verifyPaypalProfile':
      'Подтвердите email PayPal в профиле перед переводом.',
    'transferOut.toast.successPaypal': 'Перевод успешен! {{amount}} {{currency}} переведено на {{recipient}}. ID выплаты: {{payoutId}}',
    'transferOut.toast.successBank': 'Перевод инициирован! Перевод {{amount}} {{currency}} обработан.',
    'transferOut.toast.errorTransfer': 'Не удалось инициировать перевод',
  },
  pt: {
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Carregando informações da transferência...',
    'transferOut.paypalSetupAlert':
      'Você pode adicionar e verificar um email do PayPal em Perfil → Pagamentos (transferência de saída) e voltar aqui quando quiser.',
    'transferOut.openProfile': 'Abrir perfil',
    'transferOut.paymentSources': 'Fontes de pagamento',
    'transferOut.payoutSetupTitle': 'Mais opções de recebimento',
    'transferOut.payoutSetupIntro':
      'Você pode adicionar ou gerenciar formas de recebimento a qualquer momento em Perfil → Pagamentos (transferência de saída) ou Fontes de pagamento. Para usar uma opção abaixo, ative-a lá primeiro:',
    'transferOut.payoutSetupPaypal': 'PayPal — adicione e verifique um email de pagamentos.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — vincule sua conta de vendedor para transferências diretas (comerciantes).',
    'transferOut.payoutSetupBank':
      'Conta bancária — conecte um banco em Fontes de pagamento e ative recebimentos por banco no Perfil.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Taxa de processamento Stripe:',
    'transferOut.stripeFeeNote':
      'Nota: o Stripe cobra {{fee}} por este pagamento. A taxa está incluída no total deduzido do saldo.',
    'transferOut.title': 'Transferir Fundos',
    'transferOut.subtitle': 'Transfira fundos do seu saldo {{currency}} para seus métodos de pagamento',
    'transferOut.backToProfile': 'Voltar para o Perfil',
    'transferOut.currentBalance': 'Saldo Atual',
    'transferOut.available': 'Disponível para transferência',
    'transferOut.cannotTransfer': 'Não é Possível Transferir',
    'transferOut.unsupportedCurrency': 'PayPal não suporta transferências em {{currency}}',
    'transferOut.noMethods': 'Nenhum método de pagamento disponível para transferências em {{currency}}',
    'transferOut.addMethod': 'Adicionar Método de Pagamento',
    'transferOut.noBalance': 'Você não tem saldo {{currency}} para transferir. Adicione fundos ao seu saldo primeiro.',
    'transferOut.amountTitle': 'Valor da Transferência',
    'transferOut.amountSubtitle': 'Insira o valor que deseja transferir (máx: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Valor ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Máx',
    'transferOut.selectMethod': 'Selecionar Método de Pagamento',
    'transferOut.selectMethodSubtitle': 'Escolha para onde deseja transferir seu {{currency}}',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Transferir para sua conta PayPal',
    'transferOut.setPaypalId': 'Defina seu ID PayPal',
    'transferOut.creditCard': 'Cartão de Crédito',
    'transferOut.bankAccount': 'Conta Bancária',
    'transferOut.default': 'Padrão',
    'transferOut.enterPaypalEmail': 'Insira seu endereço de email PayPal',
    'transferOut.confirm': 'Confirmar',
    'transferOut.emailSaved': 'Este email será salvo para transferências futuras',
    'transferOut.summaryTitle': 'Resumo da Transferência',
    'transferOut.reviewTransferHint':
      'Insira um valor e selecione um método de pagamento para ver taxas e concluir a transferência.',
    'transferOut.amountFromBalance': 'Valor do seu saldo:',
    'transferOut.paypalFee': 'Taxa de processamento PayPal:',
    'transferOut.youWillReceive': 'Você receberá:',
    'transferOut.feeNote': 'Nota: O PayPal cobra {{fee}} para receber pagamentos. Esta taxa é deduzida pelo PayPal, não por nós.',
    'transferOut.bankFee': 'Taxa de transferência bancária:',
    'transferOut.totalDeducted': 'Total deduzido do saldo:',
    'transferOut.processing': 'Processando Transferência...',
    'transferOut.transferFunds': 'Transferir Fundos',
    'transferOut.insufficientBalance': 'Saldo insuficiente para cobrir o valor da transferência e taxas',
    'transferOut.toast.error': 'Falha ao carregar informações de transferência',
    'transferOut.toast.noMethodOrAmount': 'Por favor, selecione um método de pagamento e insira um valor',
    'transferOut.toast.noPaypalEmail': 'Por favor, insira seu endereço de email PayPal',
    'transferOut.toast.invalidEmail': 'Por favor, insira um endereço de email válido',
    'transferOut.toast.invalidAmount': 'Por favor, insira um valor válido',
    'transferOut.toast.insufficientBalance': 'Valor da transferência excede o saldo disponível',
    'transferOut.toast.verifyPaypalProfile':
      'Verifique seu email PayPal no perfil antes de transferir.',
    'transferOut.toast.successPaypal': 'Transferência bem-sucedida! {{amount}} {{currency}} transferido para {{recipient}}. ID de pagamento: {{payoutId}}',
    'transferOut.toast.successBank': 'Transferência iniciada! Transferência de {{amount}} {{currency}} foi processada.',
    'transferOut.toast.errorTransfer': 'Falha ao iniciar transferência',
  },
  el: {
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Φόρτωση πληροφοριών μεταφοράς...',
    'transferOut.paypalSetupAlert':
      'Μπορείτε να προσθέσετε και να επαληθεύσετε email PayPal στο Προφίλ → Πληρωμές (εξερχόμενη μεταφορά) και να επιστρέψτε εδώ όταν θέλετε.',
    'transferOut.openProfile': 'Άνοιγμα προφίλ',
    'transferOut.paymentSources': 'Πηγές πληρωμής',
    'transferOut.payoutSetupTitle': 'Περισσότερες επιλογές πληρωμών',
    'transferOut.payoutSetupIntro':
      'Μπορείτε να προσθέτετε ή να διαχειρίζεστε τρόπους πληρωμής οποτεδήποτε στο Προφίλ → Πληρωμές (εξερχόμενη μεταφορά) ή Πηγές πληρωμής. Για να χρησιμοποιήσετε μια επιλογή παρακάτω, ενεργοποιήστε την πρώτα εκεί:',
    'transferOut.payoutSetupPaypal': 'PayPal — προσθέστε και επαληθεύστε email πληρωμών.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — συνδέστε λογαριασμό πωλητή για άμεσες μεταφορές (έμποροι).',
    'transferOut.payoutSetupBank':
      'Τραπεζικός λογαριασμός — συνδέστε τράπεζα στις Πηγές πληρωμής και ενεργοποιήστε τραπεζικές πληρωμές στο Προφίλ.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Τέλος επεξεργασίας Stripe:',
    'transferOut.stripeFeeNote':
      'Σημείωση: Η Stripe χρεώνει {{fee}} για αυτή την πληρωμή. Το τέλος περιλαμβάνεται στο σύνολο που αφαιρείται από το υπόλοιπο.',
    'transferOut.title': 'Μεταφορά Χρημάτων',
    'transferOut.subtitle': 'Μεταφέρετε χρήματα από το υπόλοιπο {{currency}} σας στις μεθόδους πληρωμής σας',
    'transferOut.backToProfile': 'Πίσω στο Προφίλ',
    'transferOut.currentBalance': 'Τρέχον Υπόλοιπο',
    'transferOut.available': 'Διαθέσιμο για μεταφορά',
    'transferOut.cannotTransfer': 'Δεν Μπορεί να Μεταφερθεί',
    'transferOut.unsupportedCurrency': 'Το PayPal δεν υποστηρίζει μεταφορές {{currency}}',
    'transferOut.noMethods': 'Δεν υπάρχουν διαθέσιμες μέθοδοι πληρωμής για μεταφορές {{currency}}',
    'transferOut.addMethod': 'Προσθήκη Μεθόδου Πληρωμής',
    'transferOut.noBalance': 'Δεν έχετε υπόλοιπο {{currency}} για μεταφορά. Προσθέστε πρώτα χρήματα στο υπόλοιπό σας.',
    'transferOut.amountTitle': 'Ποσό Μεταφοράς',
    'transferOut.amountSubtitle': 'Εισάγετε το ποσό που θέλετε να μεταφέρετε (μέγιστο: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Ποσό ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Μέγιστο',
    'transferOut.selectMethod': 'Επιλογή Μεθόδου Πληρωμής',
    'transferOut.selectMethodSubtitle': 'Επιλέξτε πού θέλετε να μεταφέρετε τα {{currency}} σας',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Μεταφορά στον λογαριασμό PayPal σας',
    'transferOut.setPaypalId': 'Ορίστε το ID PayPal σας',
    'transferOut.creditCard': 'Πιστωτική Κάρτα',
    'transferOut.bankAccount': 'Τραπεζικός Λογαριασμός',
    'transferOut.default': 'Προεπιλογή',
    'transferOut.enterPaypalEmail': 'Εισάγετε τη διεύθυνση email PayPal σας',
    'transferOut.confirm': 'Επιβεβαίωση',
    'transferOut.emailSaved': 'Αυτό το email θα αποθηκευτεί για μελλοντικές μεταφορές',
    'transferOut.summaryTitle': 'Περίληψη Μεταφοράς',
    'transferOut.amountFromBalance': 'Ποσό από το υπόλοιπό σας:',
    'transferOut.paypalFee': 'Τέλος επεξεργασίας PayPal:',
    'transferOut.youWillReceive': 'Θα λάβετε:',
    'transferOut.feeNote': 'Σημείωση: Το PayPal χρεώνει {{fee}} για την παραλαβή πληρωμών. Αυτό το τέλος αφαιρείται από το PayPal, όχι από εμάς.',
    'transferOut.bankFee': 'Τέλος τραπεζικής μεταφοράς:',
    'transferOut.totalDeducted': 'Συνολικό ποσό που αφαιρέθηκε από το υπόλοιπο:',
    'transferOut.processing': 'Επεξεργασία Μεταφοράς...',
    'transferOut.transferFunds': 'Μεταφορά Χρημάτων',
    'transferOut.insufficientBalance': 'Ανεπαρκές υπόλοιπο για να καλύψει το ποσό μεταφοράς και τα τέλη',
    'transferOut.toast.error': 'Αποτυχία φόρτωσης πληροφοριών μεταφοράς',
    'transferOut.toast.noMethodOrAmount': 'Παρακαλώ επιλέξτε μια μέθοδο πληρωμής και εισάγετε ένα ποσό',
    'transferOut.toast.noPaypalEmail': 'Παρακαλώ εισάγετε τη διεύθυνση email PayPal σας',
    'transferOut.toast.invalidEmail': 'Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email',
    'transferOut.toast.invalidAmount': 'Παρακαλώ εισάγετε ένα έγκυρο ποσό',
    'transferOut.toast.insufficientBalance': 'Το ποσό μεταφοράς υπερβαίνει το διαθέσιμο υπόλοιπο',
    'transferOut.toast.verifyPaypalProfile':
      'Επαληθεύστε το email PayPal στο προφίλ σας πριν τη μεταφορά.',
    'transferOut.toast.successPaypal': 'Η μεταφορά ολοκληρώθηκε με επιτυχία! {{amount}} {{currency}} μεταφέρθηκαν στο {{recipient}}. ID πληρωμής: {{payoutId}}',
    'transferOut.toast.successBank': 'Η μεταφορά ξεκίνησε! Η μεταφορά {{amount}} {{currency}} έχει επεξεργαστεί.',
    'transferOut.toast.errorTransfer': 'Αποτυχία έναρξης μεταφοράς',
  },
  de: {
    'transferOut.pct25': '25 %',
    'transferOut.pct50': '50 %',
    'transferOut.pct75': '75 %',
    'transferOut.loading': 'Transferinformationen werden geladen...',
    'transferOut.paypalSetupAlert':
      'Sie können unter Profil → Auszahlungen (Transfer hinaus) eine PayPal-Auszahlungs-E-Mail hinzufügen und verifizieren und später hierher zurückkehren.',
    'transferOut.openProfile': 'Profil öffnen',
    'transferOut.paymentSources': 'Zahlungsquellen',
    'transferOut.payoutSetupTitle': 'Weitere Auszahlungsoptionen',
    'transferOut.payoutSetupIntro':
      'Sie können Auszahlungsmethoden jederzeit unter Profil → Auszahlungen (Transfer hinaus) oder Zahlungsquellen hinzufügen oder verwalten. Um eine der folgenden Optionen zu nutzen, aktivieren Sie sie zuerst dort:',
    'transferOut.payoutSetupPaypal': 'PayPal — Auszahlungs-E-Mail hinzufügen und verifizieren.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — Verkäuferkonto für Direktüberweisungen verbinden (Händler).',
    'transferOut.payoutSetupBank':
      'Bankkonto — Bank unter Zahlungsquellen verbinden und Bankauszahlungen im Profil aktivieren.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Stripe-Verarbeitungsgebühr:',
    'transferOut.stripeFeeNote':
      'Hinweis: Stripe berechnet {{fee}} für diese Auszahlung. Die Gebühr ist in der vom Guthaben abgezogenen Summe enthalten.',
    'transferOut.title': 'Geld transferieren',
    'transferOut.subtitle': 'Übertragen Sie Geld von Ihrem {{currency}}-Guthaben auf Ihre Zahlungsmethoden',
    'transferOut.backToProfile': 'Zurück zum Profil',
    'transferOut.currentBalance': 'Aktuelles Guthaben',
    'transferOut.available': 'Verfügbar für Transfer',
    'transferOut.cannotTransfer': 'Kann nicht transferieren',
    'transferOut.unsupportedCurrency': 'PayPal unterstützt keine {{currency}}-Transfers',
    'transferOut.noMethods': 'Keine Zahlungsmethoden für {{currency}}-Transfers verfügbar',
    'transferOut.addMethod': 'Zahlungsmethode hinzufügen',
    'transferOut.noBalance': 'Sie haben kein {{currency}}-Guthaben zum Transferieren. Fügen Sie zuerst Geld zu Ihrem Guthaben hinzu.',
    'transferOut.amountTitle': 'Transferbetrag',
    'transferOut.amountSubtitle': 'Geben Sie den Betrag ein, den Sie transferieren möchten (max: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Betrag ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Max',
    'transferOut.selectMethod': 'Zahlungsmethode auswählen',
    'transferOut.selectMethodSubtitle': 'Wählen Sie, wohin Sie Ihr {{currency}} transferieren möchten',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'An Ihr PayPal-Konto transferieren',
    'transferOut.setPaypalId': 'Ihre PayPal-ID festlegen',
    'transferOut.creditCard': 'Kreditkarte',
    'transferOut.bankAccount': 'Bankkonto',
    'transferOut.default': 'Standard',
    'transferOut.enterPaypalEmail': 'Geben Sie Ihre PayPal-E-Mail-Adresse ein',
    'transferOut.confirm': 'Bestätigen',
    'transferOut.emailSaved': 'Diese E-Mail wird für zukünftige Transfers gespeichert',
    'transferOut.summaryTitle': 'Transfer-Zusammenfassung',
    'transferOut.reviewTransferHint':
      'Geben Sie einen Betrag ein und wählen Sie eine Zahlungsmethode, um Gebühren zu sehen und den Transfer abzuschließen.',
    'transferOut.amountFromBalance': 'Betrag von Ihrem Guthaben:',
    'transferOut.paypalFee': 'PayPal-Verarbeitungsgebühr:',
    'transferOut.youWillReceive': 'Sie erhalten:',
    'transferOut.feeNote': 'Hinweis: PayPal berechnet {{fee}} für den Empfang von Zahlungen. Diese Gebühr wird von PayPal abgezogen, nicht von uns.',
    'transferOut.bankFee': 'Banktransfer-Gebühr:',
    'transferOut.totalDeducted': 'Gesamt vom Guthaben abgezogen:',
    'transferOut.processing': 'Transfer wird verarbeitet...',
    'transferOut.transferFunds': 'Geld transferieren',
    'transferOut.insufficientBalance': 'Unzureichendes Guthaben, um Transferbetrag und Gebühren zu decken',
    'transferOut.toast.error': 'Transferinformationen konnten nicht geladen werden',
    'transferOut.toast.noMethodOrAmount': 'Bitte wählen Sie eine Zahlungsmethode und geben Sie einen Betrag ein',
    'transferOut.toast.noPaypalEmail': 'Bitte geben Sie Ihre PayPal-E-Mail-Adresse ein',
    'transferOut.toast.invalidEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    'transferOut.toast.invalidAmount': 'Bitte geben Sie einen gültigen Betrag ein',
    'transferOut.toast.insufficientBalance': 'Transferbetrag übersteigt verfügbares Guthaben',
    'transferOut.toast.verifyPaypalProfile':
      'Bestätigen Sie Ihre PayPal-E-Mail im Profil, bevor Sie transferieren.',
    'transferOut.toast.successPaypal': 'Transfer erfolgreich! {{amount}} {{currency}} an {{recipient}} transferiert. Auszahlungs-ID: {{payoutId}}',
    'transferOut.toast.successBank': 'Transfer initiiert! {{amount}} {{currency}}-Transfer wurde verarbeitet.',
    'transferOut.toast.errorTransfer': 'Transfer konnte nicht initiiert werden',
  },
  ro: {
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Se încarcă informațiile despre transfer...',
    'transferOut.paypalSetupAlert':
      'Puteți adăuga și verifica un email PayPal în Profil → Plăți (transfer ieșire) și reveniți aici când doriți.',
    'transferOut.openProfile': 'Deschide profilul',
    'transferOut.paymentSources': 'Surse de plată',
    'transferOut.payoutSetupTitle': 'Mai multe opțiuni de plată',
    'transferOut.payoutSetupIntro':
      'Puteți adăuga sau gestiona metode de plată oricând în Profil → Plăți (transfer ieșire) sau Surse de plată. Pentru a folosi o opțiune de mai jos, activați-o mai întâi acolo:',
    'transferOut.payoutSetupPaypal': 'PayPal — adăugați și verificați un email pentru plăți.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — legați contul de vânzător pentru transferuri directe (comercianți).',
    'transferOut.payoutSetupBank':
      'Cont bancar — conectați o bancă în Surse de plată și activați plățile bancare în Profil.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Taxă procesare Stripe:',
    'transferOut.stripeFeeNote':
      'Notă: Stripe percepe {{fee}} pentru această plată. Taxa este inclusă în totalul dedus din sold.',
    'transferOut.title': 'Transfer Extern',
    'transferOut.subtitle': 'Transferați fonduri din soldul dvs. {{currency}} către metodele dvs. de plată',
    'transferOut.backToProfile': 'Înapoi la Profil',
    'transferOut.currentBalance': 'Sold Actual',
    'transferOut.available': 'Disponibil pentru transfer',
    'transferOut.cannotTransfer': 'Nu se Poate Transfera',
    'transferOut.unsupportedCurrency': 'PayPal nu suportă transferuri în {{currency}}',
    'transferOut.noMethods': 'Nu sunt disponibile metode de plată pentru transferuri în {{currency}}',
    'transferOut.addMethod': 'Adaugă Metodă de Plată',
    'transferOut.noBalance': 'Nu aveți sold {{currency}} de transferat. Adăugați mai întâi fonduri la sold.',
    'transferOut.amountTitle': 'Suma Transferului',
    'transferOut.amountSubtitle': 'Introduceți suma pe care doriți să o transferați (max: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Suma ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Max',
    'transferOut.selectMethod': 'Selectează Metodă de Plată',
    'transferOut.selectMethodSubtitle': 'Alegeți unde doriți să transferați {{currency}}',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Transferați în contul dvs. PayPal',
    'transferOut.setPaypalId': 'Setați ID-ul dvs. PayPal',
    'transferOut.creditCard': 'Card de Credit',
    'transferOut.bankAccount': 'Cont Bancar',
    'transferOut.default': 'Implicit',
    'transferOut.enterPaypalEmail': 'Introduceți adresa dvs. de email PayPal',
    'transferOut.confirm': 'Confirmă',
    'transferOut.emailSaved': 'Acest email va fi salvat pentru transferuri viitoare',
    'transferOut.summaryTitle': 'Rezumat Transfer',
    'transferOut.reviewTransferHint':
      'Introduceți o sumă și selectați o metodă de plată pentru a vedea comisioanele și a finaliza transferul.',
    'transferOut.amountFromBalance': 'Suma din soldul dvs.:',
    'transferOut.paypalFee': 'Taxă procesare PayPal:',
    'transferOut.youWillReceive': 'Veți primi:',
    'transferOut.feeNote': 'Notă: PayPal percepe {{fee}} pentru primirea plăților. Această taxă este dedusă de PayPal, nu de noi.',
    'transferOut.bankFee': 'Taxă transfer bancar:',
    'transferOut.totalDeducted': 'Total dedus din sold:',
    'transferOut.processing': 'Se procesează Transferul...',
    'transferOut.transferFunds': 'Transferă Fonduri',
    'transferOut.insufficientBalance': 'Sold insuficient pentru a acoperi suma transferului și taxele',
    'transferOut.toast.error': 'Nu s-au putut încărca informațiile despre transfer',
    'transferOut.toast.noMethodOrAmount': 'Vă rugăm să selectați o metodă de plată și să introduceți o sumă',
    'transferOut.toast.noPaypalEmail': 'Vă rugăm să introduceți adresa dvs. de email PayPal',
    'transferOut.toast.invalidEmail': 'Vă rugăm să introduceți o adresă de email validă',
    'transferOut.toast.invalidAmount': 'Vă rugăm să introduceți o sumă validă',
    'transferOut.toast.insufficientBalance': 'Suma transferului depășește soldul disponibil',
    'transferOut.toast.verifyPaypalProfile':
      'Verificați emailul PayPal din profil înainte de transfer.',
    'transferOut.toast.successPaypal': 'Transfer reușit! {{amount}} {{currency}} transferat către {{recipient}}. ID plată: {{payoutId}}',
    'transferOut.toast.successBank': 'Transfer inițiat! Transferul de {{amount}} {{currency}} a fost procesat.',
    'transferOut.toast.errorTransfer': 'Nu s-a putut iniția transferul',
  },
  sr: {
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Учитавање података о трансферу...',
    'transferOut.paypalSetupAlert':
      'Можете додати и потврдити PayPal имејл у Профил → Исплате (одлазни трансфер) и вратити се овде кад год желите.',
    'transferOut.openProfile': 'Отвори профил',
    'transferOut.paymentSources': 'Извори плаћања',
    'transferOut.payoutSetupTitle': 'Још опција за исплате',
    'transferOut.payoutSetupIntro':
      'Можете додавати или управљати начинима исплате у било ком тренутку у Профил → Исплате (одлазни трансфер) или Извори плаћања. Да бисте користили опцију испод, прво је укључите тамо:',
    'transferOut.payoutSetupPaypal': 'PayPal — додајте и потврдите имејл за исплате.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — повежите налог продавца за директне трансфере (трговци).',
    'transferOut.payoutSetupBank':
      'Банковни рачун — повежите банку у Изворима плаћања и укључите банковне исплате у Профилу.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Накнада за обраду Stripe:',
    'transferOut.stripeFeeNote':
      'Напомена: Stripe наплаћује {{fee}} за ову исплату. Накнада је укључена у укупан износ скинут са стања.',
    'transferOut.title': 'Исплата',
    'transferOut.subtitle': 'Пренесите средства са вашег {{currency}} стања на ваше начине плаћања',
    'transferOut.backToProfile': 'Назад на профил',
    'transferOut.currentBalance': 'Тренутно стање',
    'transferOut.available': 'Доступно за пренос',
    'transferOut.cannotTransfer': 'Није могуће извршити пренос',
    'transferOut.unsupportedCurrency': 'ПаyПал не подржава {{currency}} трансфере',
    'transferOut.noMethods': 'Нема доступних начина плаћања за {{currency}} трансфере',
    'transferOut.addMethod': 'Додај начин плаћања',
    'transferOut.noBalance': 'Немате {{currency}} стање за пренос. Прво додајте средства на свој салдо.',
    'transferOut.amountTitle': 'Износ за пренос',
    'transferOut.amountSubtitle': 'Унесите износ који желите да пренесете (макс: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Износ ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Макс',
    'transferOut.selectMethod': 'Изаберите начин плаћања',
    'transferOut.selectMethodSubtitle': 'Изаберите где желите да пренесете ваш {{currency}}',
    'transferOut.paypal': 'ПаyПал',
    'transferOut.paypalDesc': 'Пренос на ваш ПаyПал налог',
    'transferOut.setPaypalId': 'Подесите свој ПаyПал ИД',
    'transferOut.creditCard': 'Кредитна картица',
    'transferOut.bankAccount': 'Банковни рачун',
    'transferOut.default': 'Подразумевано',
    'transferOut.enterPaypalEmail': 'Унесите своју ПаyПал имејл адресу',
    'transferOut.confirm': 'Потврди',
    'transferOut.emailSaved': 'Овај имејл ће бити сачуван за будуће трансфере',
    'transferOut.summaryTitle': 'Резиме трансфера',
    'transferOut.reviewTransferHint':
      'Унесите износ и изаберите начин плаћања да видите накнаде и завршите трансфер.',
    'transferOut.amountFromBalance': 'Износ са вашег стања:',
    'transferOut.paypalFee': 'Накнада за обраду ПаyПал-а:',
    'transferOut.youWillReceive': 'Примићете:',
    'transferOut.feeNote': 'Напомена: ПаyПал наплаћује {{fee}} за пријем уплата. Ову накнаду одбија ПаyПал, а не ми.',
    'transferOut.bankFee': 'Накнада за банковни трансфер:',
    'transferOut.totalDeducted': 'Укупно одбијено са стања:',
    'transferOut.processing': 'Обрада трансфера...',
    'transferOut.transferFunds': 'Пренеси средства',
    'transferOut.insufficientBalance': 'Недовољно стање за покривање износа трансфера и накнада',
    'transferOut.toast.error': 'Није успело учитавање информација о трансферу',
    'transferOut.toast.noMethodOrAmount': 'Молимо изаберите начин плаћања и унесите износ',
    'transferOut.toast.noPaypalEmail': 'Молимо унесите своју ПаyПал имејл адресу',
    'transferOut.toast.invalidEmail': 'Молимо унесите важећу имејл адресу',
    'transferOut.toast.invalidAmount': 'Молимо унесите важећи износ',
    'transferOut.toast.insufficientBalance': 'Износ трансфера премашује расположиво стање',
    'transferOut.toast.verifyPaypalProfile':
      'Потврдите PayPal имејл у профилу пре трансфера.',
    'transferOut.toast.successPaypal': 'Трансфер успешан! {{amount}} {{currency}} пребачено на {{recipient}}. ИД исплате: {{payoutId}}',
    'transferOut.toast.successBank': 'Трансфер покренут! Трансфер од {{amount}} {{currency}} је обрађен.',
    'transferOut.toast.errorTransfer': 'Покретање трансфера није успело',
  },
  pl: {
    'transferOut.pct25': '25%',
    'transferOut.pct50': '50%',
    'transferOut.pct75': '75%',
    'transferOut.loading': 'Ładowanie informacji o transferze...',
    'transferOut.paypalSetupAlert':
      'Możesz dodać i zweryfikować e-mail PayPal w Profilu → Wypłaty (transfer wychodzący) i wrócić tutaj, kiedy będziesz gotowy.',
    'transferOut.openProfile': 'Otwórz profil',
    'transferOut.paymentSources': 'Źródła płatności',
    'transferOut.payoutSetupTitle': 'Więcej opcji wypłat',
    'transferOut.payoutSetupIntro':
      'Możesz w dowolnym momencie dodać lub zarządzać metodami wypłat w Profilu → Wypłaty (transfer wychodzący) lub Źródła płatności. Aby skorzystać z opcji poniżej, najpierw włącz ją tam:',
    'transferOut.payoutSetupPaypal': 'PayPal — dodaj i zweryfikuj e-mail wypłat.',
    'transferOut.payoutSetupStripeConnect':
      'Stripe Connect — połącz konto sprzedawcy dla przelewów bezpośrednich (handlowcy).',
    'transferOut.payoutSetupBank':
      'Konto bankowe — połącz bank w Źródłach płatności i włącz wypłaty bankowe w Profilu.',
    'transferOut.stripeConnect': 'Stripe Connect',
    'transferOut.stripeFee': 'Opłata za przetwarzanie Stripe:',
    'transferOut.stripeFeeNote':
      'Uwaga: Stripe pobiera {{fee}} za tę wypłatę. Opłata jest wliczona w sumę potrąconą z salda.',
    'transferOut.title': 'Transfer Wychodzący',
    'transferOut.subtitle': 'Transferuj środki ze swojego salda {{currency}} do swoich metod płatności',
    'transferOut.backToProfile': 'Powrót do Profilu',
    'transferOut.currentBalance': 'Aktualne Saldo',
    'transferOut.available': 'Dostępne do transferu',
    'transferOut.cannotTransfer': 'Nie Można Transferować',
    'transferOut.unsupportedCurrency': 'PayPal nie obsługuje transferów w {{currency}}',
    'transferOut.noMethods': 'Brak dostępnych metod płatności do transferów w {{currency}}',
    'transferOut.addMethod': 'Dodaj Metodę Płatności',
    'transferOut.noBalance': 'Nie masz salda {{currency}} do transferu. Najpierw dodaj środki do swojego salda.',
    'transferOut.amountTitle': 'Kwota Transferu',
    'transferOut.amountSubtitle': 'Wprowadź kwotę, którą chcesz transferować (maks: {{balance}} {{currency}})',
    'transferOut.amountLabel': 'Kwota ({{currency}})',
    'transferOut.amountPlaceholder': '0.00',
    'transferOut.max': 'Maks',
    'transferOut.selectMethod': 'Wybierz Metodę Płatności',
    'transferOut.selectMethodSubtitle': 'Wybierz, dokąd chcesz transferować swoje {{currency}}',
    'transferOut.paypal': 'PayPal',
    'transferOut.paypalDesc': 'Transferuj do swojego konta PayPal',
    'transferOut.setPaypalId': 'Ustaw swoje ID PayPal',
    'transferOut.creditCard': 'Karta Kredytowa',
    'transferOut.bankAccount': 'Konto Bankowe',
    'transferOut.default': 'Domyślne',
    'transferOut.enterPaypalEmail': 'Wprowadź swój adres email PayPal',
    'transferOut.confirm': 'Potwierdź',
    'transferOut.emailSaved': 'Ten email zostanie zapisany do przyszłych transferów',
    'transferOut.summaryTitle': 'Podsumowanie Transferu',
    'transferOut.reviewTransferHint':
      'Wprowadź kwotę i wybierz metodę płatności, aby zobaczyć opłaty i dokończyć transfer.',
    'transferOut.amountFromBalance': 'Kwota z Twojego salda:',
    'transferOut.paypalFee': 'Opłata za przetwarzanie PayPal:',
    'transferOut.youWillReceive': 'Otrzymasz:',
    'transferOut.feeNote': 'Uwaga: PayPal pobiera {{fee}} za otrzymywanie płatności. Ta opłata jest potrącana przez PayPal, nie przez nas.',
    'transferOut.bankFee': 'Opłata za transfer bankowy:',
    'transferOut.totalDeducted': 'Łącznie odliczone z salda:',
    'transferOut.processing': 'Przetwarzanie Transferu...',
    'transferOut.transferFunds': 'Transferuj Środki',
    'transferOut.insufficientBalance': 'Niewystarczające saldo do pokrycia kwoty transferu i opłat',
    'transferOut.toast.error': 'Nie udało się załadować informacji o transferze',
    'transferOut.toast.noMethodOrAmount': 'Proszę wybrać metodę płatności i wprowadzić kwotę',
    'transferOut.toast.noPaypalEmail': 'Proszę wprowadzić swój adres email PayPal',
    'transferOut.toast.invalidEmail': 'Proszę wprowadzić prawidłowy adres email',
    'transferOut.toast.invalidAmount': 'Proszę wprowadzić prawidłową kwotę',
    'transferOut.toast.insufficientBalance': 'Kwota transferu przekracza dostępne saldo',
    'transferOut.toast.verifyPaypalProfile':
      'Zweryfikuj e-mail PayPal w profilu przed transferem.',
    'transferOut.toast.successPaypal': 'Transfer zakończony sukcesem! {{amount}} {{currency}} przetransferowano do {{recipient}}. ID wypłaty: {{payoutId}}',
    'transferOut.toast.successBank': 'Transfer zainicjowany! Transfer {{amount}} {{currency}} został przetworzony.',
    'transferOut.toast.errorTransfer': 'Nie udało się zainicjować transferu',
  },
};
